import { useEffect } from 'react'; // useState

// project-imports
import Routes from 'routes';
import ThemeCustomization from 'themes';


import Locales from 'components/Locales';
import RTLLayout from 'components/RTLLayout';
import ScrollTop from 'components/ScrollTop';

import Snackbar from 'components/@extended/Snackbar';
import Notistack from 'components/third-party/Notistack';
import WindowFocusHandler from 'contexts/WindowFocusHandler';

import { JWTProvider as AuthProvider } from 'contexts/JWTContext';
import { useSelector } from 'react-redux';
import { ContemporaryProvider } from 'contexts/ContemporaryContext';
import { ExamRecorderProvider } from 'contexts/ExamRecorder';
import { CanvasProvider } from 'contexts/CanvasContext';
import { getNormalizeFileUrl } from 'utils/getNormalizeFileUrl';
// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //

const App = () => {

  const favIconPath = useSelector((state: any) => state?.organization?.favIcon?.[0]?.path);

  const favIcon = useSelector((state: any) => state?.organization?.favIcon?.[0]);
  
  const defaultFavicon = '/vid_lms_logo_webicon.png';

  const favicon = favIconPath ? getNormalizeFileUrl(favIcon, defaultFavicon) : defaultFavicon;

  useEffect(() => {
    let link: any = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }

    link.href = favicon;
  }, [favicon]);



  return (
    <ThemeCustomization>
      <RTLLayout>
        <Locales>
          <ScrollTop>
            <ContemporaryProvider>
              <AuthProvider>
                <ExamRecorderProvider>
                  <CanvasProvider>
                    
                      <Notistack>
                        <Routes />
                        {/* <Customization /> */}
                        <Snackbar />
                        <WindowFocusHandler />
                      </Notistack>
                    
                  </CanvasProvider>
                </ExamRecorderProvider>
              </AuthProvider>
            </ContemporaryProvider>
          </ScrollTop>
        </Locales>
      </RTLLayout>
    </ThemeCustomization>
  );
};

export default App;
